
import { Options, Vue } from "vue-class-component";
import RequestedItem from "../../service/RequestedItemService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required} from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import AutoComplete from "primevue/autocomplete";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";

@Options({
  title: 'Requested Items',
  components: {
    AutoComplete,
  },
})
export default class RequestedItems extends Vue {
  private profilerService;
  private profilerList = [];
  private posService;
  private itemList = [];
  private lists = [];
  private dialogTitle;
  private keyword = '';
  private toast;
  private goToFirstLink = 0;
  private currentStoreID = 0;
  private requestedItem;
  private productDialog = false;
  private submitted = false;
  private sendSMSConfirmationDialog = false; 
  private statusDialog = false;
  private checkPagination = true;
  private totalRecords = 0;
  private limit = 0;
  private home = { icon: "pi pi-home", to: "/" };
  private storeList = [];
  private items = [
    { label: "Initialization", to: "/home/initialization" },
    { label: "Requested Items", to: "requested-items" },
  ];

  private selectedStore = {
    id: 0
  };

  private item = {
    id: 0,
    description: "",
    status: "Active",
    quantity: "0",
  };
  
  private state = reactive({
    requestedItem: "",
    customerName: "",
    contactNumber: "",
  });

  private validationRules = {
    requestedItem: {
      required,
    },
    customerName: {
      required,
    },
    contactNumber: {
    required,
    //exactLength10: (value) => (value && value.length === 10),  // Ensures the value has exactly 10 digits
    numeric: (value) => /^[0-9]+$/.test(value),
  },
  };
  
  private v$ = useVuelidate(this.validationRules, this.state);

  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
    this.loadList(event.first);
  }

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.profilerService = new ProfilerService();
    this.requestedItem = new RequestedItem();
    this.toast = new Toaster();
    this.posService = new PosService();
  }
  
  //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadList(0);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {
    this.clearItem();

    this.submitted = false;
    this.dialogTitle = "Add New Item";
    this.productDialog = true;
  }

  //CLOSE THE ITEM DAILOG BOX
  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
  }

  //ADD OR UPDATE THE ITEM VIA HTTP
  saveItem(isFormValid) {
    this.submitted = true; 
    if (isFormValid) {
      if (this.item.id != 0) {
        this.requestedItem
          .updateItem(this.item, this.state)
          .then((res) => {
            this.loadList(this.goToFirstLink);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
          });
      } else {
        this.requestedItem
          .saveItem(this.item, this.state, this.currentStoreID)
          .then((res) => {
            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
          });
      }
      this.productDialog = false;
      this.clearItem();
    }
  }

    //OPEN DIALOG BOX TO EDIT
    editIem(data) {
      this.submitted = false;
      this.dialogTitle = "Update Item";
      this.productDialog = true;
      this.requestedItem.getItem(data).then((res) => {
  
        if (res.length > 0) {
          this.state.customerName         = res[0].customer_name;
          this.state.contactNumber        = res[0].contact_number;
          this.state.requestedItem        = res[0].item_name;
          this.item.quantity             = res[0].quantity;
          this.item.status                = res[0].status;
          this.item.description           = res[0].description == null ? "" : res[0].description;
          this.item.id                    = res[0].id;
        }
      });
    }

    //OPEN DIALOG BOX FOR CONFIRMATION
    confirmChangeStatus(data) {
      this.item.id = data.id;
      this.state.requestedItem = data.item_name;
      this.statusDialog = true;
    }

    //CHANGE THE STATUS AND SEND HTTP TO SERVER
    changeStatus() {
      this.statusDialog = false;
      this.item.status = "Delete";
      this.requestedItem.changeStatus(this.item).then((res) => {
        this.loadList(0);
        //SHOW NOTIFICATION
        this.toast.handleResponse(res);
      });
    }

    //FETCH THE DATA FROM SERVER
    loadList(page) {
      this.requestedItem.getItems(this.selectedStore.id,this.keyword,page,).then((data) => {
        this.lists              = data.records;
        this.totalRecords       = data.totalRecords;
        this.storeList          = data.stores;
        this.limit              = data.limit;
        this.currentStoreID     = data.currentStoreID;
      });
    }

    clearItem() {
      this.item = {
        id: 0,
        description: "",
        status: "Active",
        quantity:"0",
      };

      this.state.customerName =  "";
      this.state.contactNumber =  "";
      this.state.requestedItem =  "";
    }

    loadSearchData() {
      this.submitted = true;
      if (this.keyword) {
        this.goToFirstLink = 0;
        this.loadList(0);
      }
    }
    // send SMS
    openSendSMS(data) {  
      this.sendSMSConfirmationDialog = true; // Close the dialog first
      this.state.contactNumber = data.contact_number;
      this.state.customerName = data.customer_name;
      this.state.requestedItem = data.item_name;
      this.item.id = data.id; 
      }

    SendSMS() {
      this.sendSMSConfirmationDialog = false; // Close the dialog first
      this.requestedItem.sendSMS(this.state, this.item).then((res) => {
          this.loadList(0);
          //SHOW NOTIFICATION
          this.toast.handleResponse(res);
        });  
    }

    validateContactNumber(event: Event) {
      const input = event.target as HTMLInputElement;
    
      const sanitizedValue = input.value.replace(/\D/g, ''); // Remove non-numeric characters
      
      if (sanitizedValue.length <= 10) {
        this.state.contactNumber = sanitizedValue; // Update the reactive state
      }
    }
    searchItem(event) {
      setTimeout(() => {
        this.posService.searchItem(event.query.trim()).then((data) => {
          this.itemList = data.records;
          });
      }, 200);
    }

    handleItemSelect(event) {
      // Manually set the value for the requestedItem
      this.state.requestedItem = event.value.product_name;
    }

    searchProfiler(event) {
    setTimeout(() => {
      this.profilerService.searchProfiler(event.query.trim()).then((data) => {
        this.profilerList = data.records;
      });
    }, 200);
  }
  selectProfile(event) {
    this.state.customerName = event.value.account_title;
    this.state.contactNumber = event.value.contact_no;
  }
}
